import { useEffect, useMemo, useState } from "react";
import {
    Avatar, Divider, IconButton, ListItemText, Menu, Typography, MenuItem,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../../hooks/useTranslate";
import axiosManager from "../../services/axiosManager";
import { formatTo } from "../../utils/dateTimeHelper";
import IconProfile from "../../assets/images/icons/profile.svg?react";
import useStatuses from "../../context/status/useStatuses";
import useUserAuth from "../../auth/hooks/useUserAuth";
import "./ProfileMenu.css";

const ProfileMenu = (props) => {
    const { notClickable } = props;
    const { t } = useTranslate();
    const navigate = useNavigate();
    const { logOut } = useUserAuth();
    const { isApplicant } = useStatuses();

    const [anchorEl, setAnchorEl] = useState(null);
    const [currentTime, setCurrentTime] = useState(new Date());

    const open = Boolean(anchorEl);

    const greeting = useMemo(() => {
        const hour = currentTime.getHours();
        if (hour < 12) return "Good Morning";
        if (hour < 17) return "Good Afternoon";
        return "Good Evening";
    }, [currentTime]);

    const { data: user } = useQuery({
        queryKey: ["parent/contacts"],
        queryFn: () => axiosManager.get$("parent/api/Contacts").then((response) => response?.data),
        initialData: {},
        retry: 0,
    });

    // const fullName = `${user.forename} ${user.surname}`;
    const fullName = user.forename;

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const handleEditProfile = () => {
        setAnchorEl(false);
        navigate("my-details");
    };

    const handleLogout = () => {
        setAnchorEl(false);
        logOut();
    };

    return (
        <div className="profile-menu">
            <div className="profile-menu__info">
                <Typography className="greeting-text">{`${greeting} ${fullName}`}</Typography>
                <Typography className="time-text">{formatTo(currentTime, "MMM dd, HH:mm a")}</Typography>
            </div>

            <IconButton
                className="profile-menu__avatar"
                onClick={(e) => (notClickable ? undefined : setAnchorEl(e.currentTarget))}
            >
                <Avatar className="user-avatar">
                    <IconProfile />
                </Avatar>
                {!notClickable && <ExpandMore className="dropdown-icon" />}
            </IconButton>

            <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(false)}
                className="profile-menu"
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                {!isApplicant && (
                    <>
                        <MenuItem onClick={handleEditProfile} className="menu-item">
                            <ListItemText primary={t("header.editProfile")} />
                        </MenuItem>
                        <Divider className="menu-divider" />
                    </>
                )}
                <MenuItem onClick={handleLogout} className="menu-item logout-item">
                    <ListItemText primary={t("header.logOut")} />
                </MenuItem>
            </Menu>
        </div>
    );
};

export default ProfileMenu;
